import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Asterisk = createReactComponent("Asterisk", ["svg", defaultAttributes, [["path", {
  d: "M12 6v12",
  key: "lqrgx8"
}], ["path", {
  d: "M17.196 9L6.804 15",
  key: "wu5l3j"
}], ["path", {
  d: "M6.804 9l10.392 6",
  key: "i3kzks"
}]]]);
export default Asterisk;